import { render } from "./EmpresaPrincipal.vue?vue&type=template&id=35716a37&scoped=true"
import script from "./EmpresaPrincipal.vue?vue&type=script&lang=js"
export * from "./EmpresaPrincipal.vue?vue&type=script&lang=js"

import "./EmpresaPrincipal.vue?vue&type=style&index=0&id=35716a37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35716a37"]])

export default __exports__